<div
  class="image-container container"
  style="background-image: url('/assets/images/lifestyle/facilitati.jpg')"
>
  <h3
    class="title"
  >
    Living by nature
  </h3>
</div>

<div
  class="container"
>
  <p
    class="downtown-description"
    [innerHTML]="'pages.downtown_life.facilities.paragraph' | translate"
  >
  </p>
</div>

<h1
  class="page-title"
>
  {{ 'pages.downtown_life.facilities.title' | translate }}
</h1>

<div
  fxLayout="row wrap"
  fxLayoutAlign="center center"
  class="container"
>
  <div
    fxLayout="column"
    fxLayoutAlign="center center"
    *ngFor="let reason of reasons"
    class="lifestyle-item"
  >
    <div
      fxLayout="row"
      fxLayoutAlign="center center"
      class="icon-container gradient-background"
    >
      <img [src]="reason.image.url" alt="" class="icon">
    </div>
    <h3
      class="title"
    >
      {{ reason.title }}
    </h3>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/downtown-life/facilities.component.html